import { observable } from 'mobx'
import { Model, type ModelProps } from '@/infra/model'
import { Id } from '@/infra/id'
import { Member } from '@/features/iam/members/Member'

export type RelationManagerProps = ModelProps<RelationManager>

/**
 * The relation manager assigned to a job.
 */
export class RelationManager extends Model<RelationManager> {
  /**
   * The ID of the job; a job has at most one relation manager.
   */
  id = Id.none

  /**
   * The relation manager.
   */
  @observable accessor member = Member.none
}
